import groq from 'groq';

import { ASSET, RICH_TEXT } from '../common';

export const IMAGE_WITH_CALLOUTS = groq`
  title,
  image { ${ASSET} },
  callouts[] {
    size,
    label,
    description,
    references[] { ${RICH_TEXT} },
    x,
    y
  }
`;

export const IMAGE_WITH_CALLOUTS_BLOCK = groq`
  _type == 'imageWithCallouts' => @-> {
    ${IMAGE_WITH_CALLOUTS}
  }
`;
